(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/register/register.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/register/register.js');
'use strict';

const {
  useState
} = React;
const {
  useHistory
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const StepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls;
const {
  Form,
  ControlGroup,
  Inputv2
} = svs.ui.reactForm;
const {
  GridBase
} = svs.tb_ui_react.gridbase;
const {
  ReactInfoButtonText
} = svs.tb_ui;
const helpers = svs.playerRegistration.helpers;
const service = svs.playerRegistration.service;
const {
  trackCustomerRegistrationAsync
} = svs.playerRegistration.tracking;
const {
  showTechnicalError,
  showHowWeUseInfoDialog,
  showExpiredIdentificationDialog,
  showCantBecomeACustomer
} = svs.playerRegistration.dialogs;
const {
  routes
} = svs.playerRegistration.constants;
const {
  Header,
  Footer,
  DesktopContentConstrain,
  PageTitle,
  FadeInSlideWrapper,
  GeneralTermsDocLink,
  PersonalInformationDocLink,
  GameRulesPageLink
} = svs.playerRegistration.components;
let warningMessageTimer;
const modes = {
  REACTIVATED_EMAIL: 0,
  REACTIVATED_NO_EMAIL: 1,
  RETAIL: 2,
  NEW: 3
};
const Register = () => {
  var _svs$playerRegistrati, _customer$email;
  const history = useHistory();
  const {
    startTime
  } = ReactRedux.useSelector(state => state.playerregistrationreact);
  const customer = (_svs$playerRegistrati = svs.playerRegistration.data) === null || _svs$playerRegistrati === void 0 ? void 0 : _svs$playerRegistrati.customer;
  const extraData = ReactRedux.useSelector(state => state.playerregistrationreact);
  const isRetail = extraData.isRetailCustomer;
  const isReactivatedEmail = extraData.isReactivatedCustomer && Boolean(customer === null || customer === void 0 ? void 0 : customer.email);
  const isReactivatedNoEmail = extraData.isReactivatedCustomer && !(customer !== null && customer !== void 0 && customer.email);
  const returnUrl = helpers.getReturnUrl() || svs.core.urlMapping.get('newCustomer');
  const isNewCustomerOnlyStep1 = returnUrl === svs.core.urlMapping.get('newCustomer');
  const isShortRegistrationFlow = extraData.isShortRegistrationFlow || isNewCustomerOnlyStep1;
  const [mobile, setMobile] = useState((customer === null || customer === void 0 ? void 0 : customer.mobile) || '');
  const [email, setEmail] = useState((customer === null || customer === void 0 || (_customer$email = customer.email) === null || _customer$email === void 0 ? void 0 : _customer$email.toLowerCase()) || '');
  const [validMobile, setValidMobile] = useState(true);
  const [validEmail, setValidEmail] = useState(true);
  const [emailCustomError, setEmailCustomError] = useState('');
  const [mobileCustomError, setMobileCustomError] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  let mode;
  switch (true) {
    case isReactivatedEmail:
      mode = modes.REACTIVATED_EMAIL;
      break;
    case isReactivatedNoEmail:
      mode = modes.REACTIVATED_NO_EMAIL;
      break;
    case isRetail:
      mode = modes.RETAIL;
      break;
    default:
      mode = modes.NEW;
      break;
  }
  const navigateToNext = async (showKycQuestions, isBlocked) => {
    const queryString = returnUrl ? "?returnUrl=".concat(encodeURIComponent(returnUrl)) : '';
    const customerRegistrationCompletionUrl = svs.core.urlMapping.get('customerRegistrationCompletion');
    const accountCreatedUrl = "".concat(customerRegistrationCompletionUrl).concat(routes.ACCOUNT_CREATED).concat(queryString);
    const kycUrl = "".concat(routes.KYC).concat(queryString);

    if (showKycQuestions) {
      history.push(kycUrl);
      return;
    } else if (isBlocked) {
      const showNationalSuspensionMessage = () => new Promise(resolve => {
        svs.accountservices.national_suspension_message.showNationalSuspensionMessage(() => resolve());
      });
      await showNationalSuspensionMessage();
    }

    if (isShortRegistrationFlow) {
      svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
    } else {
      svs.utils.url.navigate(svs.utils.url.makeInternal(accountCreatedUrl, svs.core.urlMapping.get('startPage')));
    }
  };
  const handleInputChange = e => {
    e.preventDefault();
    if (warningMessageTimer) {
      clearTimeout(warningMessageTimer);
    }
    const value = e.target.value;
    if (e.target.name === 'email') {
      const isValidEmail = helpers.validateEmail(value);
      setEmailCustomError('');
      setEmail(value);
      if (!isValidEmail) {
        warningMessageTimer = setTimeout(() => {
          setValidEmail(false);
        }, 1000);
      } else {
        setValidEmail(true);
      }
    } else {
      const isValidMobile = helpers.validatePhoneNumber(value);
      setMobileCustomError('');
      let formattedNumber = value;
      if (formattedNumber.length > 2 && formattedNumber.slice(0, 2) === '46') {
        formattedNumber = "0".concat(formattedNumber.slice(2));
      }
      if (formattedNumber.length > 3 && formattedNumber.slice(0, 3) === '+46') {
        formattedNumber = "0".concat(formattedNumber.slice(3));
      }
      if (formattedNumber.length > 4 && formattedNumber.slice(0, 4) === '0046') {
        formattedNumber = "0".concat(formattedNumber.slice(4));
      }
      setMobile(formattedNumber);
      if (!isValidMobile) {
        warningMessageTimer = setTimeout(() => {
          setValidMobile(false);
        }, 1000);
      } else {
        setValidMobile(true);
      }
    }
  };
  const onRegistrationError = err => {
    if (err) {
      switch (err.code) {
        case 10050:
          setEmailCustomError('Ange giltig e-postadress');
          break;
        case 10056:
          setEmailCustomError('E-postadressen är registrerad på en annan kund');
          break;
        case 12110:
          setMobileCustomError('Felaktigt mobilnummer');
          break;
        case 12560:
          showCantBecomeACustomer();
          break;
        case 12570:
          setMobileCustomError('Mobilnumret är registrerad på en annan kund');
          break;
        case 12580:
        case 12581:
          showExpiredIdentificationDialog();
          break;
        default:
          svs.playerRegistration.logger.warn('Customer registration technical error', err);
          showTechnicalError();
          break;
      }
    } else {
      svs.playerRegistration.logger.warn('Customer registration technical error, no error object');
      showTechnicalError();
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    const customerData = {
      postToken: customer.token,
      email,
      source: helpers.getDevice()
    };
    if (mobile.length > 0) {
      const formattedNumber = mobile.replace(/\+46/, '0').replace(/^0046+/, '0').replace(/-|\s/g, '');
      customerData.cellPhone = formattedNumber;
    }
    if (validMobile || validEmail) {
      var _registerCustomerResp, _registerCustomerResp2;
      const registerCustomerResponse = await service.registerCustomerAsync(customerData, customer.eid);
      const trackingLabel = customer.eid === 'frejaeid' ? 'frejaeid' : 'bankid';
      if (registerCustomerResponse.error) {
        onRegistrationError(registerCustomerResponse.error);
        return;
      }
      const preferencesResponse = await service.checkFreshPreferencesDataAsync();
      if (preferencesResponse.error) {
        svs.playerRegistration.logger.warn('Could not retrieve preferences, going to forward new customer without having verified preferences.', preferencesResponse.error);
      }

      await svs.accountservices.martech_helper.setPersonalizedContentFlag();

      if (startTime) {
        await trackCustomerRegistrationAsync({
          label: trackingLabel,
          duration: Date.now() - startTime
        });
      }
      const showKycQuestions = Boolean(registerCustomerResponse === null || registerCustomerResponse === void 0 || (_registerCustomerResp = registerCustomerResponse.data) === null || _registerCustomerResp === void 0 || (_registerCustomerResp = _registerCustomerResp.session) === null || _registerCustomerResp === void 0 ? void 0 : _registerCustomerResp.showKycQuestions);
      const isBlocked = registerCustomerResponse === null || registerCustomerResponse === void 0 || (_registerCustomerResp2 = registerCustomerResponse.data) === null || _registerCustomerResp2 === void 0 || (_registerCustomerResp2 = _registerCustomerResp2.session) === null || _registerCustomerResp2 === void 0 ? void 0 : _registerCustomerResp2.isBlocked;
      navigateToNext(showKycQuestions, isBlocked);
    }
    setIsButtonDisabled(false);
  };
  svs.playerRegistration.logger.debug('KUND:    ', extraData);
  return React.createElement(React.Fragment, null, React.createElement(Header, null), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, null, !isShortRegistrationFlow && React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement(StepIndicatorBalls, {
    isLabelsHidden: true,
    isShowDottedLines: true,
    step: 1
  })), React.createElement(FadeInSlideWrapper, null, React.createElement("div", null, React.createElement(PageTitle, {
    isSuppressData: true
  }, "Hej", ' ', customer === null || customer === void 0 ? void 0 : customer.name, "!"), React.createElement("p", {
    className: "h4 margin-bottom-1"
  }, React.createElement("span", {
    className: "registration-bread-text"
  }, mode === modes.REACTIVATED_NO_EMAIL && 'Innan vi kan återaktivera ditt konto behöver du fylla i din e-postadress.', mode === modes.REACTIVATED_EMAIL && 'Innan du återaktiverar ditt konto behöver du kontrollera att din e-postadress fortfarande är aktuell.', mode === modes.RETAIL && 'Innan du kan spela behöver du skapa ett konto.', mode === modes.NEW && 'Innan du kan spela, skrapa eller rätta behöver du skapa ditt spelkonto hos oss.'))), React.createElement(Form, {
    id: "registerSubmitForm",
    onSubmit: handleSubmit
  }, React.createElement(ControlGroup, {
    infoMessage: "S\xE5 att du kan ta emot spelresultat",
    isLessSpace: true,
    v2: true
  }, React.createElement(ControlGroup, {
    errorMessage: emailCustomError || 'Det här ser inte ut som en riktig e-postadress',
    hasError: !validEmail || Boolean(emailCustomError.length),
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    inputHelpText: "Din e-postadress",
    label: "Fyll i din e-postadress* ",
    name: "email",
    onChange: handleInputChange,
    value: email
  }))), React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(ControlGroup, {
    className: "margin-top-2",
    infoMessage: "S\xE5 att vi kan kontakta dig om du vinner stort",
    isLessSpace: true,
    v2: true
  }, React.createElement(ControlGroup, {
    errorMessage: mobileCustomError || 'Ogiltigt format på mobilnumret',
    hasError: !validMobile || Boolean(mobileCustomError.length),
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    explanation: "123",
    inputHelpText: "Ditt mobilnummer",
    label: "Fyll i ditt mobilnummer",
    name: "mobile",
    onChange: handleInputChange,
    value: mobile
  }))))), React.createElement("div", null, React.createElement("div", {
    className: "margin-top-2 margin-bottom-2"
  }, React.createElement(Button, {
    block: true,
    disabled: isButtonDisabled || !email || !validMobile || !validEmail,
    focus: true,
    form: "registerSubmitForm",
    type: "submit"
  }, React.createElement(React.Fragment, null, (mode === modes.REACTIVATED_NO_EMAIL || mode === modes.REACTIVATED_EMAIL) && 'Återaktivera mitt konto', mode === modes.RETAIL && 'Fortsätt', mode === modes.NEW && 'Skapa konto '))), !isRetail && React.createElement("p", {
    className: "margin-bottom-1"
  }, "Genom att bli kund accepterar jag AB Svenska Spels", ' ', React.createElement(GeneralTermsDocLink, null), ",", ' ', React.createElement(GameRulesPageLink, null), ' ', "och", ' ', React.createElement(PersonalInformationDocLink, null), "."), React.createElement("div", {
    className: "register-clear-both margin-top-1"
  }, React.createElement(ReactInfoButtonText, {
    isUnderline: true,
    onClick: showHowWeUseInfoDialog,
    text: "S\xE5 anv\xE4nder vi dina kontaktuppgifter"
  }), React.createElement("p", {
    className: "margin-v-1"
  }, "Obligatorisk uppgift*")), React.createElement(Footer, {
    isRetail: isRetail
  }))))));
};
svs.playerRegistration.pages.register.Register = Register;

 })(window);